module.exports = __webpack_public_path__ + "img/car_sendai08.43e40ac4.jpg";